import React, { useMemo } from 'react';

import { useAppDispatch } from 'utils/hooks';

import {
  CartOrderOption,
  createCartOrderOption,
  deleteCartOrderOption,
} from 'domains/cart_order_options';

import type { OptionAPIData } from 'domains/option_groups';

type CartAddOnOptionProps = {
  option: OptionAPIData;
  cartOrderOption?: CartOrderOption;
  groupId: number;
};

function CartAddOnOption(props: CartAddOnOptionProps) {
  const { option, cartOrderOption, groupId } = props;
  const dispatch = useAppDispatch();

  const savedOrderOption = useMemo(
    () => cartOrderOption?.option_api_id === option.id,
    [(option.id, cartOrderOption)]
  );

  function handleOptionSelect(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      dispatch(createCartOrderOption.pending(option.id));
    } else if (cartOrderOption) {
      dispatch(deleteCartOrderOption.pending(cartOrderOption.id));
    }
  }

  return (
    <li
      className={`order-option-item ${savedOrderOption ? 'selected' : ''}`}
      data-value={option.id}
    >
      <label className="order-option-label">
        {/* <FontAwesomeIcon
          icon={savedOrderOption ? ['far', 'check-square'] : ['far', 'square']}
          size="lg"
        /> */}
        <img src={option.image_url} alt="" />
        {option.name}
        <input
          onChange={handleOptionSelect}
          key={option.id}
          type="checkbox"
          name={groupId.toString()}
          className="screen-reader-text"
          checked={!!savedOrderOption}
        />
      </label>
    </li>
  );
}

export default CartAddOnOption;
